import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import LFGLogo from '../../assets/lfg_logo.svg.js';

var Logo = function Logo(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    width: 500,
    src: LFGLogo
  }, props));
};

export default Logo;
